<div class="modal-wrapper">
  <button class="modal-close-btn" [disabled]="slideLocked" (click)="dismiss(false)" aria-label="Close">
    <ion-icon name="close-outline"></ion-icon>
  </button>
  <div class="modal-icon">
    <ion-icon name="warning-outline"></ion-icon>
  </div>

  <h2>{{uncheckingTitle}}</h2>

  <p>
    {{uncheckingMessage}}
  </p>

  <!-- Thumbnails -->
  <div class="thumbnail-row" *ngIf="mediaItems?.length">
    <ng-container *ngFor="let media of visibleThumbnails">

      <!-- Images -->
      <div class="thumb" *ngIf="media.FileType === 'images'">
        <img [src]="getMediaPath(media)" [alt]="media.FileName" />
      </div>

      <!-- Videos -->
      <div class="thumb thumb-icon" *ngIf="media.FileType === 'videos'">
        <video [src]="getMediaPath(media)" preload="metadata"></video>
        <div class="thumb-overlay">
          <ion-icon name="play-circle-outline"></ion-icon>
        </div>
      </div>

      <!-- Files -->
      <div class="thumb thumb-icon" *ngIf="media.FileType === 'files'">
        <ion-icon name="document-outline"></ion-icon>
        <span class="file-ext">{{ getFileExtension(media.FileName) }}</span>
      </div>

    </ng-container>
    <div class="thumb thumb-count" *ngIf="extraCount > 0">
      <span>+{{ extraCount }}</span>
    </div>
  </div>

  <div class="slide-track" [class.slide-danger]="slideProgress >= 0.75" (mousedown)="onSlideStart($event)"
    (mousemove)="onSlideMove($event)" (mouseup)="onSlideEnd()" (touchstart)="onSlideStart($event)"
    (touchmove)="onSlideMove($event)" (touchend)="onSlideEnd()">

    <div class="slide-fill" [style.width.px]="fillWidth"></div>

    <span class="slide-hint" [style.opacity]="hintOpacity">
      <ion-icon name="chevron-forward-outline"></ion-icon>
      {{"self_pwa_text.uncheck_delete_slide" | translate}}
    </span>

    <div class="slide-thumb" [style.left.px]="thumbLeft">
      <ion-icon [name]="thumbIcon"></ion-icon>
    </div>
  </div>
</div>